import moment from "moment";
import axios from "axios"


export const myTimeZone = "Asia/Bangkok"

export function removeLocalStorage(){
    localStorage.removeItem('user_id')
    localStorage.removeItem('urlAvartar')
    localStorage.removeItem('user_name_surname')
    localStorage.removeItem('access_token')
    localStorage.removeItem('vuex')
}

// export  const  SUBMIT_TYPE_PLUS_EDIT = {
//     prepare : "prepare",
//     ct : "ct"
// }

 



export const MAX_PATHO_MEMBER_ID  =  15
export const MAX_PATHO_MEMBER_NAME =  150
export const MAX_PATHO_MEMBER_HOUSE_ADDRESS =  15
export const MAX_PATHO_MEMBER_ADDRESS_TXT =  250


export const MAX_IMAGE_UPLOAD_FOR_NEWS = 15


export const DATA_BL_PARASITE_MODEL = { "id": "","name": "","result_dat_aval_id" : "","result_dat_aval": "" , "enable": false} 

export const  DATAPATHOGEN_MODEL =  { "id": "","title": "", "idpart" : "","descp_part": "","result_type" : "","result_dat_aval": "","enable": false}

export const DATACYTOSPECLN_MODEL =  { "dat_prepare": { "dat": "", "user_rec": "", "avartar": "", "date_rec": "", "time_rec": "" },
                                       "dat_ct"     : { "dat": "", "user_rec": "", "avartar": "", "date_rec": "", "time_rec": "" },
                                       "img"        : { "dat": [], "user_rec": "", "avartar": "", "date_rec": "", "time_rec": "" },
                                       "diag_code"  : { "dat": [], "user_rec": "", "avartar": "", "date_rec": "", "time_rec": "" },
                                       "status"     : { "id": "", "name": "" },
                                       "assigned_to_user": { "id": "", "name": "" } ,
                                       "data_req"   : [],
                                       "data_plus": {
                                                       "dat_prepare": [],
                                                       "dat_ct": [],
                                                       "img": [],
                                                        "diag_code": []
                                                     }
                                       }


export const DATABIOPSPECLN_MODEL =  { "dat_prepare": { "dat": "", "user_rec": "", "avartar": "", "date_rec": "", "time_rec": "" },
                                       "dat_ct": { "dat": "", "user_rec": "", "avartar": "", "date_rec": "", "time_rec": "" },
                                       "img": { "dat": [], "user_rec": "", "avartar": "", "date_rec": "", "time_rec": "" },
                                       "diag_code": { "dat": [], "user_rec": "", "avartar": "", "date_rec": "", "time_rec": "" },
                                       "status": { "id": "", "name": "" },
                                       "assigned_to_user": { "id": "", "name": "" } ,
                                       "data_req" : [] ,
                                       "data_plus": {
                                                    "dat_prepare": [],
                                                    "dat_ct": [],
                                                    "img": [],
                                                    "diag_code": []
                                                    }
                                       }


export const DATANECROPSPECLN_MODEL =  { "dat_prepare": { "dat": "", "user_rec": "", "avartar": "", "date_rec": "", "time_rec": "" },
                                         "dat_ct": { "dat": "", "user_rec": "", "avartar": "", "date_rec": "", "time_rec": "" },
                                         "img": { "dat": [], "user_rec": "", "avartar": "", "date_rec": "", "time_rec": "" },
                                         "diag_code": { "dat": [], "user_rec": "", "avartar": "", "date_rec": "", "time_rec": "" },
                                         "status": { "id": "", "name": "" },
                                         "assigned_to_user": { "id": "", "name": "" } ,
                                         "data_req" : [] ,
                                         "data_plus": {
                                                    "dat_prepare": [],
                                                    "dat_ct": [],
                                                    "img": [],
                                                    "diag_code": []
                                                    }
                                        }


export const DATA_ORGA_LN_MODEL = {
    "dat_prepare": {"dat": "", "dat_txt": "", "user_rec": "", "avartar": "", "datetime_rec": "", "id": ""},
    "dat_ct": {"dat": "", "dat_txt": "", "user_rec": "", "avartar": "", "datetime_rec": "", "id": ""},
    "status": {"id": "", "name": ""},
    "assigned_to_user": {"id": "", "name": ""},
    "img": {"dat": [], "user_rec": "", "avartar": "", "date_rec": "", "time_rec": ""},
    "diag_code": {"dat": [], "user_rec": "", "avartar": "", "date_rec": "", "time_rec": ""},
    //  data example
    // {"idbact": "1","name_bact": "Beta staphylococcus intermedius group3+" ,"bact_remark" : ""  ... }
    "data_bact": [
        {"idbact_uuid": "","idbact": "", "name_bact": "","bact_remark": "", "drugs": []}    //  { "id":"1","name":""Enrofloxacin,"result_dat":{ "mic_prefix":"" ,"mic_val": "", "result":"R/I/S","remark":"","sort_id": "","iddrug_uuid": ""}  },
    ],
    "current_datetime": null,
    "data_req": [],
    "data_plus": {
        "dat_prepare": [],
        "dat_ct": [],
        "data": [{"uuid": "","idbact": "", "name_bact": "", "drugs": []} ],
        "img": [],
        "diag_code": []
    }
}
export const DATA_PARASITE_LN_MODEL = {
    "dat_prepare": {"dat": "", "dat_txt": "", "user_rec": "", "avartar": "", "datetime_rec": "", "id": ""},
    "dat_ct": {"dat": "", "dat_txt": "", "user_rec": "", "avartar": "", "datetime_rec": "", "id": ""},
    "status": {"id": "", "name": ""},
    "assigned_to_user": {"id": "", "name": ""},
    "img": {"dat": [], "user_rec": "", "avartar": "", "date_rec": "", "time_rec": ""},
    "diag_code": {"dat": [], "user_rec": "", "avartar": "", "date_rec": "", "time_rec": ""},
    //  data example
    // {"idbact": "1","name_bact": "Beta staphylococcus intermedius group3+" ,"bact_remark" : ""  ... }
    "data_bact": [
                   {"idbact_uuid": "","idbact": "", "name_bact": "","bact_remark": "", "drugs": []}    //  { "id":"1","name":""Enrofloxacin,"result_dat":{ "mic_prefix":"" ,"mic_val": "", "result":"R/I/S","remark":"","sort_id": "","iddrug_uuid": ""}  },
                 ],
    "current_datetime": null,
    "data_req": [],
    "data_plus": {
                    "dat_prepare": [],
                    "dat_ct": [],
                    "data": [{"uuid": "","idbact": "", "name_bact": "", "drugs": []} ],
                    "img": [],
                    "diag_code": []
                  }
    }


export const DATA_PARA_LN_MODEL = {
        "dat_prepare": {"dat": "", "dat_txt": "", "user_rec": "", "avartar": "", "datetime_rec": "", "id": ""},
        "dat_ct": {"dat": "", "dat_txt": "", "user_rec": "", "avartar": "", "datetime_rec": "", "id": ""},
        "status": {"id": "", "name": ""},
        "assigned_to_user": {"id": "", "name": ""},
        "img": {"dat": [], "user_rec": "", "avartar": "", "date_rec": "", "time_rec": ""},
        "diag_code": {"dat": [], "user_rec": "", "avartar": "", "date_rec": "", "time_rec": ""},
        //  data example
        // {"idbact": "1","name_bact": "Beta staphylococcus intermedius group3+" ,"bact_remark" : ""  ... }
        "data_bact": [
                       {"idbact_uuid": "","idbact": "", "name_bact": "","bact_remark": "", "drugs": []}    //  { "id":"1","name":""Enrofloxacin,"result_dat":{ "mic_prefix":"" ,"mic_val": "", "result":"R/I/S","remark":"","sort_id": "","iddrug_uuid": ""}  },
                     ],
        "current_datetime": null,
        "data_req": [],
        "data_plus": {
                        "dat_prepare": [],
                        "dat_ct": [],
                        "data": [{"uuid": "","idbact": "", "name_bact": "", "drugs": []} ],
                        "img": [],
                        "diag_code": []
                      }
        }

export const DATA_BACT_LN_MODEL = {
                                    "dat_prepare": {"dat": "", "dat_txt": "", "user_rec": "", "avartar": "", "datetime_rec": "", "id": ""},
                                    "dat_ct": {"dat": "", "dat_txt": "", "user_rec": "", "avartar": "", "datetime_rec": "", "id": ""},
                                    "status": {"id": "", "name": ""},
                                    "assigned_to_user": {"id": "", "name": ""},
                                    "img": {"dat": [], "user_rec": "", "avartar": "", "date_rec": "", "time_rec": ""},
                                    "diag_code": {"dat": [], "user_rec": "", "avartar": "", "date_rec": "", "time_rec": ""},
                                    //  data example
                                    // {"idbact": "1","name_bact": "Beta staphylococcus intermedius group3+" ,"bact_remark" : ""  ... }
                                    "data_bact": [
                                                   {"idbact_uuid": "","idbact": "", "name_bact": "","bact_remark": "", "drugs": []}    //  { "id":"1","name":""Enrofloxacin,"result_dat":{ "mic_prefix":"" ,"mic_val": "", "result":"R/I/S","remark":"","sort_id": "","iddrug_uuid": ""}  },
                                                 ],
                                    "current_datetime": null,
                                    "data_req": [],
                                    "data_plus": {
                                                    "dat_prepare": [],
                                                    "dat_ct": [],
                                                    "data": [{"uuid": "","idbact": "", "name_bact": "", "drugs": []} ],
                                                    "img": [],
                                                    "diag_code": []
                                                  }
                                    }


export const BLANK_OPD_FOR_MANUAL_LAB_AUTOMATE =  {
                                                        "address": null ,
                                                        "age": null,
                                                        "birth": null ,
                                                        "breed": null ,
                                                        "date_rec": null,
                                                        "idopd": null,
                                                        "idown": null ,
                                                        "name": null,
                                                        "owner_name": null,
                                                        "phone_mobile": null,
                                                        "sex": null ,
                                                        "species": null ,
                                                        "species_id": null ,
                                                        "visit_active":null  ,
                                                    } 
 



export const DATA_PCR_LN_MODEL =  {
                                    "dat_prepare": { "dat": "", "dat_txt": "","user_rec": "", "avartar": "", "datetime_rec": "" , "id": ""},
                                    "dat_ct": { "dat": "","dat_txt": "", "user_rec": "", "avartar": "", "datetime_rec": "" , "id": "" },
                                    "status": {"id": "", "name": ""},
                                    "assigned_to_user": {"id": "", "name": ""},
                                    "img": {"dat": [], "user_rec": "", "avartar": "", "date_rec": "", "time_rec": ""},
                                    "diag_code": {"dat": [], "user_rec": "", "avartar": "", "date_rec": "", "time_rec": ""},
                                    "id": [],
                                    "dataresultset_1" : {"idpathogen": [],  // arr of integer
                                                       "title": [],       // arr of string  such as "Canine Parvo" or "Bird sex"
                                                       "result_dat": [],  // arr of string such as "Negative" or "Positive"
                                                       "result_aval":[],  //  {}, {} , ...option {"id" : "Negative","Positive"}  or "Male","Female"
                                                       "comment_each":[] ,  // arr of string
                                                       "user_rec_id" :[] ,  // arr of integer
                                                       "user_rec_fn" : [],  // arr of string
                                                       "datetime_rec": []   // arr of date iso8601
                                                      },
                                    "dataresultset_2" : [], // [{"idpathogen": "","title":"", "result_dat": "","result_aval": [ "Negative","Positive" ],"comment_each": "", "user_rec_id" : 1 ,  "user_rec_fn" : "" , "datetime_rec" : "" , "id": ""  } ...] ,
                                    "comment" : "",
                                    "current_datetime": null,
                                    "data_req" : [] ,
                                    "data_plus": {
                                                    "dat_prepare": [],
                                                    "dat_ct": [],
                                                    "dataresultset_2": [], // [{"idpathogen": "","title":"", "result_dat": "","result_aval": [ "Negative","Positive" ],"comment_each": ""  , "user_rec_id" : 1 ,  "user_rec_fn" : "" , "datetime_rec" : "" , "id": "" } ...] ,
                                                    "img": [],
                                                    "diag_code": []
                                                 }
                                  }






export const IDLABSelected_MODEL =   {"idlab": "","kind": ""}


export const MAX_CHAR_BACT_REMARK = 150
export const MAX_CHAR_BACT_REMARK_EACH = 100
export const MAX_CHAR_PCR_COMMENT_EACH = 100
export const MAX_CHAR_PATHOGEN_TITLE = 100
export const MAX_CHAR_BACT_METHOD = 100
export const MAX_CHAR_BL_PARASITE_NAME = 64

// export const MIN_ROW_TEXT_AREA= 10

export const FONT_HOLD = `color: blue;font-size: 18px;`


export const  LOCATE_ENDPOINT_VIEWEACH_KINDLAB = {
       //  "CBC" : "/api/labcbc_spec_opdno_spec_ln", 
       "CBC" : "/api/labcbc_spec_opdno_spec_ln_v2", 
       "CYTOLOGY" :"/api/labcyto_spec_opdno_spec_ln",
       "BIOPSY" :"/api/labbiopsy_spec_opdno_spec_ln",
       "PCR" :"/api/labpcr_spec_opdno_spec_ln",
       "BACTERIAL" :"/api/labbact_by_spechnspecln",
       "ORGANISM" :"/api/laborga_by_spechnspecln",
       "NECROPSY" :"/api/labnecropsy_by_spechnspecln",
       "PARASITE" :"/api/labpara_by_spechnspecln",
}

export const month_th_abbreviation = ['ม.ค.','ก.พ.','มี.ค.','เม.ย.','พ.ค.','มิ.ย.','ก.ค.','ส.ค.','ก.ย.','ต.ค.','พ.ย.','ธ.ค.']

export const month_eng_abbreviation = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']


export const month_weekday_abbreviation = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday']




export const  LOCATE_ENDPOINT_UPDATEEACH_KINDLAB = {
    "CBC" : "",  // mai mee
    "CYTOLOGY" :"/api/update_labcyto_by_ln",
    "BIOPSY" :"/api/update_labbiopsy_by_ln",
    "PCR" :"/api/update_labpcr_by_ln",
    "BACTERIAL" :"/api/lab_bact_updatebyspecln",
    "ORGANISM" :"/api/lab_orga_updatebyspecln",
    "NECROPSY" :"/api/lab_necropsy_updatebyspecln",
    "PARASITE" :"/api/lab_parasite_updatebyspecln",
}


//
// export  function  getNameAndSurname(){
//     return localStorage.getItem('user_name_surname')
// }



export async function logout(fp){
    const  dat ={
        "fp": fp
    }
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("access_token")}`
    await  axios.post(`${getBaseURLforBackEnd()}/api/logout`,dat,getConfigAxios())
        .then((res) => {
           console.log(res)
        })

        .catch(function(error) {
            console.log(error)
        });


}


export function fixedNumber(num,digit){
        if(num === null){
            num =0
        }
        return num.toFixed(digit)


}

export function getUserIDfromLocalStorage(){
    return localStorage.getItem('user_id')
}



export async function getCurrentDate(){
    return  await new Promise((resolve,reject) => {
                                        axios.get(`${getBaseURLforBackEnd()}/api/curdatetime`,getConfigAxios())
                                            .then((response)=>{
                                                var tmpMonth = ''
                                                if ((response.data.current_month.toString()).length === 1){
                                                    tmpMonth =   '0'+response.data.current_month.toString()
                                                }else{
                                                    tmpMonth =   response.data.current_month.toString()
                                                }

                                                var tmpDay = ''
                                                if ((response.data.current_day.toString()).length === 1){
                                                    tmpDay =   '0'+response.data.current_day.toString()
                                                }else{
                                                    tmpDay =    response.data.current_day.toString()
                                                }

                                                var tmpHour = ''
                                                if ((response.data.current_hour.toString()).length === 1){
                                                    tmpHour =   '0'+response.data.current_hour.toString()
                                                }else{
                                                    tmpHour =    response.data.current_hour.toString()
                                                }

                                                var tmpMinute = ''
                                                if ((response.data.current_minute.toString()).length === 1){
                                                    tmpMinute =   '0'+response.data.current_minute.toString()
                                                }else{
                                                    tmpMinute =    response.data.current_minute.toString()
                                                }

                                                resolve(response.data.current_year
                                                    +'-'+
                                                    tmpMonth
                                                    //  ((response.data.current_month.toString()).length === 1) ? ('0'+response.data.current_month.toString() ): (response.data.current_month.toString() )
                                                    +'-'+
                                                    tmpDay
                                                    +'T'+tmpHour+':'+tmpMinute+':00')
                                            })
                                            .catch((error)=>{
                                                reject(error)
                                                // console.log(error)
                                                // vm.$buefy.toast.open({
                                                //     duration: 500,
                                                //     message:  `${error}`,
                                                //     position: 'is-bottom',
                                                //     type: 'is-warning'
                                                // })
                                            })

    })
}




export async function getMyTemplate(user_id){
    const dat = {
        "user" : user_id
    }
    /* eslint-disable no-console */

    // console.log(dat)
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("access_token")}`
    return await new Promise( (resolve,reject)=> {
          axios.post(`${getBaseURLforBackEnd()}/api/listoflabnonautomate_templete`,dat,getConfigAxios())
            .then(res=>{
                resolve(res)
            })
            .catch(err=>{
                reject(err)
            })
        }
    );


}




export async function checkAccessTokenWithFpValid(fp){
        const dat = {
        "fp" : fp
    }
    /* eslint-disable no-console */


     axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("access_token")}`
            return await new Promise( (resolve,reject)=> {
                    axios.post(`${getBaseURLforBackEnd()}/api/check_access_fp_valid`, dat, getConfigAxios())
                        .then((res) => {
                            resolve(res)
                        })

                        .catch(function (error) {
                            reject(error)
                        })
                }
            );


}



// export async function checkOrGetAccessFromRefreshTokenValid(fp){
//     const dat = {
//         "fp" : fp
//     }
//
//     // console.log('fp : '+fp)
//     // console.log('refresh_token : '+localStorage.getItem("refresh_token"))
//    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("refresh_token")}`
//    return  await axios.post(`${getBaseURLforBackEnd()}/refresh_token1`,dat,getConfigAxios())
//                     .then((res) => {
//                         // console.log('T')
//
//                         return {
//                                access_token :res.data.access_token,
//                                status: true
//                         }
//                     })
//
//                     .catch(function(error) {
//                         if (error.response && error.response.status === 401) {
//                             // console.log('F')
//                             return {
//                                 access_token :'',
//                                 status: false
//                             }
//                         }
//
//                     });
//
//
//
// }




export  function  getRandomFloat() {
    return (Math.random() * (1000.120 - 0.0200) + 0.0200).toFixed(2)

}

export  function  getRandomInt() {
        return Math.floor(Math.random() * (1000 - 5 + 1)) + 5
}

export function customFormatDate(strDateWantTo){
   //  console.log(strDateWantTo)
   // return   moment(strDateWantTo).format('DD/MM/YYYY')
    if(strDateWantTo) {
        return moment(strDateWantTo).isValid ? moment(strDateWantTo).format('DD/MM/YYYY') : ""
    }
    return ""


}

export function customFormatTime(strTimeWantTo){
    if(strTimeWantTo) {
         return moment(strTimeWantTo, "HH:mm:ss").isValid ? moment(strTimeWantTo, "HH:mm:ss a").format('hh:mm:ss a') : ""
        //return moment(strTimeWantTo, "HH:mm:ss").isValid ? moment(strTimeWantTo, "HH:mm:ss").format('hh:mm:ss') : ""
    }
    return ""
}


export  function genUUID(length)
{
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}


export function getRandomColor() {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }



export function getHardColor(index){
    const colorHard = ['blue','red','teal','indigo','darkgreen','midnightblue','maroon','darkslategray','saddlebrown','steelblue','firebrick']
    return colorHard[index]
}


export function getLightColor(index){
    const colorLight = ['lightpink','bisque','lightcoral','lightyellow','lightgreen','lightcyan','lightblue','lightgray','lightsalmon','powderblue','aquamarine ']
    return colorLight[index]
}

export function getRgbaColor(index){
    const RgbaColor = ['rgba(0,102,255,0.0)','rgba(51,0,102,0.0)','rgba(255,102,51,0.0)','rgba(0,0,51,0.0)','rgba(102,153,102,0.0)','rgba(51,0,102,0.0)','rgba(0,0,51,0.1)','rgba(102,51,255,0.1)','rgba(255,51,255,0.1)','rgba(51,0,255,0.1)','rgba(153,0,153,0.1)']
    return RgbaColor[index]
}


export function random_rgba() {
    var o = Math.round, r = Math.random, s = 255;
    return 'rgba(' + o(r()*s) + ',' + o(r()*s) + ',' + o(r()*s) + ',' + 0.1 + ')';
}



export function formatNumber(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

export function firstSelectParam() {
    return 10
}


//
// export  function  labStatusColor(status){
//         if (status === 'Request') {
//                 return "is-light"
//         }else if (status === 'Accept'){
//                 return "is-warning"
//         }else if (status === 'Cancel'){
//                 return "is-danger"
//         }else if (status === 'Result'){
//                 return "is-success"
//         }else if (status === 'Reject') {
//             return "is-dark"
//         }
//
// }




export function statusCaption(status){
        if (status === '0') {
                return "Pending"
        }else if (status === '1'){
                return "Approve I"
        }else if (status === '2') {
                return "Approve II"
        }
         else
                return "Approve III"
}








export const CALL_FROM  = 2  // 0 == labpatho.vet.ku.ac.th or 127.0.0.1 (localhost in test) , 1 == local(172.16.2.116) , 2 == https://kuvdl.vet.ku.ac.th

export function callIMRForLocal() {
 //  return true
   return false
}







export function getBaseURLforBackEnd() {
   //  return `http://127.0.0.1:5000`
     

    // ok
     return `https://kuvdl.vet.ku.ac.th`
 //    return `http://172.16.2.117`

 //   return `http://172.16.110.230`



      // return `http://192.168.1.37:5000`
      // return `http://172.16.1.47:5000`
      // return `http://158.108.65.51`
}







export function getBaseURLforSocketIo() {
  //  return `http://127.0.0.1:4500`
     
    // ok
    return `https://kuvdl.vet.ku.ac.th`
  //   return `http://172.16.2.117:4500`

  // return `http://192.168.1.59:4500`
  //  return `http://172.16.110.230:4500`

}


export function getBaseURLAvartar(){
 //  return `http://127.0.0.1:5000/static/uploads`
   
    // ok
    return `https://kuvdl.vet.ku.ac.th/static/uploads`
 //   return `http://172.16.2.117/static/uploads`

      //  return `http://158.108.65.51/static/uploads`
      

    // return `http://192.168.1.37:5000/static/uploads/`
    // return `http://172.16.1.47:5000/static/uploads/`


  //  return `http://172.16.101.8:5000/static/uploads`
}


export function getBaseURLLabCBCImages() {
 // return `http://127.0.0.1:5000/static/lab_img_cbc/`


    // ok
      return `https://kuvdl.vet.ku.ac.th/static/lab_img_cbc/`
  //     return `http://172.16.2.117/static/lab_img_cbc/`

 //return `http://172.16.110.230/static/lab_img_cbc/`
  
}



export function getBaseURLLabNewsV2() {
  
 //  return `http://127.0.0.1:5000/static/lab_news/`

    // ok
       return `https://kuvdl.vet.ku.ac.th/static/lab_news/`
  //     return `http://172.16.2.117/static/lab_news/`
  


 // return `http://172.16.101.8:5000/static/lab_news/`
}



export function getBaseURLLabNews() {
    
    
 // return `http://127.0.0.1/static/lab_news/`


 //return `http://172.16.2.117/static/uploads/imges_news/`

    // ok
    return `https://kuvdl.vet.ku.ac.th/static/uploads/imges_news/`
  //  return `http://172.16.2.117/static/uploads/imges_news/`


    //  return `http://127.0.0.1:5000/static/uploads/imges_news/`
   //   return `http://158.108.65.51/static/uploads/imges_news/` 
    // return `http://192.168.1.37:5000/static/uploads/imges_news/`
    // return `http://172.16.1.47:5000/static/uploads/imges_news/`



   // return `http://172.16.101.8:5000/static/lab_news/`

}


 

export function getConfigAxios() {
        return   {
                  headers:{
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                  
                        // 'Access-Control-Allow-Origin': 'https://localhost:8182',
                        // 'Access-Control-Allow-Headers': '*',
                        // 'Access-Control-Allow-Credentials': "true",



                    //    'Access-Control-Allow-Origin':  'https://localhost:8182/thaiid/read.jsonp?callback&section1=true&section2a=true&section2b=true',
 
// 
                        "Access-Control-Allow-Origin": "*" ,

                        // 'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
                        // 'Access-Control-Allow-Origin' : 'https://localhost:8182/thaiid/read.jsonp?callback&section1=true&section2a=true&section2b=true',
                        // 'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
                        // 'Access-Control-Allow-Credentials':true,


                        // proxy: {
                        //     host: 'https://localhost',
                        //     port: 8182
                        //   }

                        // crossdomain: true, 
                   },
                   timeout: 1000 * 10,
   
                //    crossdomain: true, 
                  
                //    'Access-Control-Allow-Credentials':true,
                //    withCredentials: false,

                // withCredentials: false,
                // useCredentails: false ,
                // credentials: 'same-origin',
              }
}


export function getConfigAxiosFormData() {
    return   {
        headers:{
            'Content-Type': 'multipart/form-data',
        },
        timeout: 1000 * 10,
    }
}



export function spiningGif(){
    return `https://i.imgur.com/JfPpwOA.gif`
}


